function formatMoneyCents(cents, format) {
  if (typeof cents !== 'number' || isNaN(cents)) return '';

  function addCommas(numberString) {
    return numberString.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }

  function formatWithDelimiters(numberCents, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;

    const negative = numberCents < 0;
    const absCents = Math.abs(numberCents);

    let dollarsStr;
    let centsStr = '';
    if (precision === 0) {
      dollarsStr = String(Math.round(absCents / 100));
    } else {
      dollarsStr = String(Math.floor(absCents / 100));
      centsStr = decimal + String(absCents % 100).padStart(2, '0');
    }
    dollarsStr = addCommas(dollarsStr);
    if (thousands !== ',') dollarsStr = dollarsStr.replace(/,/g, thousands);

    return (negative ? '-' : '') + dollarsStr + centsStr;
  }

  const value = format || '${{amount}}';
  const match = value.match(/\{\{\s*(\w+)\s*\}\}/);
  const token = match ? match[1] : 'amount';

  let output;
  switch (token) {
    case 'amount_no_decimals':
      output = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      output = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      output = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount':
    default:
      output = formatWithDelimiters(cents, 2);
  }

  return value.replace(/\{\{\s*\w+\s*\}\}/, output);
}

if (!customElements.get('trio-buy-box')) {
  customElements.define('trio-buy-box', class TrioBuyBox extends HTMLElement {
    constructor() {
      super();
      this.mode = 'single';
      this.activeSlotIndex = null;
    }

    connectedCallback() {
      this.wrapper = this.closest('.trio-buy-box');
      this.productForm = this.closest('product-form');
      this.form = this.productForm ? this.productForm.querySelector('form') : this.closest('form');
      this.quantityInput = this.form ? this.form.querySelector('.trio-buy-box__quantity-input') : null;
      this.submitButton = this.form ? this.form.querySelector('.product-form__submit') : null;
      this.stickyButton = this.wrapper ? this.wrapper.querySelector('.trio-buy-box__sticky-button') : null;
      this.dynamicCheckout = this.wrapper ? this.wrapper.querySelector('.trio-buy-box__dynamic-checkout') : null;
      this.errorWrapper = this.wrapper ? this.wrapper.querySelector('.trio-buy-box__error-message-wrapper') : null;
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      this.scentPicker = this.querySelector('.trio-buy-box__scent-picker');
      this.slots = Array.from(this.querySelectorAll('.trio-buy-box__slot'));
      this.chooser = this.querySelector('.trio-buy-box__chooser');
      this.chooserGrid = this.querySelector('.trio-buy-box__chooser-grid');
      this.progressEl = this.querySelector('.trio-buy-box__progress');
      this.trioPriceEl = this.querySelector('.trio-buy-box__trio-price');
      this.trioSavingsEl = this.querySelector('.trio-buy-box__trio-savings');
      this.discountPct = parseFloat(this.dataset.discountPct) || 0;
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      this.staticLabel = this.dataset.staticLabel || '';

      const dataScript = this.querySelector('.trio-buy-box__eligible-data');
      try {
        this.eligibleProducts = dataScript ? JSON.parse(dataScript.textContent) : [];
      } catch (error) {
        this.eligibleProducts = [];
      }

      this.slotData = this.slots.map((slot) => {
        if (!slot.classList.contains('trio-buy-box__slot--filled')) return null;
        const price = parseInt(slot.dataset.price, 10);
        return {
          id: parseInt(slot.dataset.id, 10),
          title: slot.dataset.title,
          price: isNaN(price) ? 0 : price,
          image: slot.dataset.image || '',
        };
      });

      const submitLabel = this.submitButton ? this.submitButton.querySelector('span') : null;
      this.defaultButtonText = submitLabel ? submitLabel.textContent : '';

      this.radios = Array.from(this.querySelectorAll('input[type="radio"]'));
      this.radios.forEach((radio) => {
        radio.addEventListener('change', this.onOptionChange.bind(this));
      });

      this.slots.forEach((slot, index) => {
        slot.addEventListener('click', () => this.openChooser(index));
      });

      const closeButton = this.querySelector('.trio-buy-box__chooser-close');
      if (closeButton) closeButton.addEventListener('click', () => this.closeChooser());

      // Seeded from whatever's already filled (e.g. the trio modal opens
      // pre-filled with 3 slots) so the very first updateProgress() call
      // below doesn't mistake an already-complete initial state for a
      // fresh transition into it and fire the celebration unprompted.
      this.wasComplete = this.filledCount >= 3;

      this.renderChooserGrid();
      this.updateProgress();

      const checked = this.querySelector('input[type="radio"]:checked');
      if (checked) this.applyOption(checked);

      if (this.productForm) {
        // Capture phase on the <product-form> ancestor always runs before the
        // <form>'s own bubble-phase submit listener (added by product-form.js),
        // regardless of script load order, so stopImmediatePropagation here
        // reliably pre-empts the default single-item Ajax submit for trio.
        this.productForm.addEventListener('submit', this.onProductFormSubmit.bind(this), true);
      }
    }

    onOptionChange(evt) {
      this.applyOption(evt.target);
    }

    applyOption(radio) {
      this.mode = radio.value;

      if (this.quantityInput && radio.dataset.quantity) {
        this.quantityInput.value = radio.dataset.quantity;
      }

      if (this.scentPicker) {
        this.scentPicker.hidden = this.mode !== 'trio';
      }

      if (this.dynamicCheckout) {
        this.dynamicCheckout.hidden = this.mode === 'trio';
      }

      if (this.mode !== 'trio') this.closeChooser();

      this.updateSubmitButton();
    }

    openChooser(index) {
      this.activeSlotIndex = index;
      if (this.chooser) this.chooser.hidden = false;
    }

    closeChooser() {
      if (this.chooser) this.chooser.hidden = true;
      this.activeSlotIndex = null;
    }

    renderChooserGrid() {
      if (!this.chooserGrid) return;
      this.chooserGrid.innerHTML = '';

      this.eligibleProducts.forEach((eligibleProduct) => {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'trio-buy-box__chip';

        if (eligibleProduct.image) {
          const img = document.createElement('img');
          img.src = eligibleProduct.image;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 40;
          img.height = 40;
          chip.appendChild(img);
        }

        const name = document.createElement('span');
        name.className = 'trio-buy-box__chip-name';
        name.textContent = eligibleProduct.shortName || eligibleProduct.fullTitle;
        chip.appendChild(name);

        if (eligibleProduct.gender) {
          const gender = document.createElement('span');
          gender.className = 'trio-buy-box__chip-gender';
          gender.textContent = eligibleProduct.gender;
          chip.appendChild(gender);
        }

        chip.addEventListener('click', () => this.pickProduct(eligibleProduct));
        this.chooserGrid.appendChild(chip);
      });
    }

    pickProduct(eligibleProduct) {
      if (this.activeSlotIndex == null) return;
      this.slotData[this.activeSlotIndex] = eligibleProduct;
      this.renderSlot(this.activeSlotIndex);
      this.closeChooser();
      this.updateProgress();
      this.updateSubmitButton();
    }

    clearSlot(index) {
      this.slotData[index] = null;
      this.renderSlot(index);
      this.updateProgress();
      this.updateSubmitButton();
    }

    renderSlot(index) {
      const slot = this.slots[index];
      if (!slot) return;
      const data = this.slotData[index];

      slot.innerHTML = '';

      if (data) {
        slot.classList.add('trio-buy-box__slot--filled');
        slot.classList.remove('trio-buy-box__slot--empty');

        if (data.image) {
          const img = document.createElement('img');
          img.src = data.image;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 50;
          img.height = 50;
          slot.appendChild(img);
        }

        const name = document.createElement('span');
        name.className = 'trio-buy-box__slot-name';
        name.textContent = data.shortName || data.title;
        slot.appendChild(name);

        const clear = document.createElement('span');
        clear.className = 'trio-buy-box__slot-clear';
        clear.setAttribute('aria-label', 'Clear this scent');
        clear.textContent = '×';
        clear.addEventListener('click', (evt) => {
          evt.stopPropagation();
          this.clearSlot(index);
        });
        slot.appendChild(clear);
      } else {
        slot.classList.add('trio-buy-box__slot--empty');
        slot.classList.remove('trio-buy-box__slot--filled');

        const plus = document.createElement('span');
        plus.className = 'trio-buy-box__slot-plus';
        plus.textContent = '+';
        slot.appendChild(plus);

        const label = document.createElement('span');
        label.className = 'trio-buy-box__slot-label';
        label.textContent = 'PICK A SCENT';
        slot.appendChild(label);
      }

      slot.classList.remove('trio-buy-box__slot--enter');
      void slot.offsetWidth; // force reflow so the enter transition replays
      slot.classList.add('trio-buy-box__slot--enter');
    }

    get filledCount() {
      return this.slotData.filter(Boolean).length;
    }

    trioTotals() {
      const subtotal = this.slotData.reduce((sum, item) => sum + (item ? item.price : 0), 0);
      const discounted = Math.round((subtotal * (100 - this.discountPct)) / 100);
      return { subtotal: subtotal, discounted: discounted, savings: subtotal - discounted };
    }

    updateProgress() {
      this.dispatchProgressEvent();
      if (!this.progressEl) return;
      const count = this.filledCount;

      if (count < 3) {
        this.progressEl.textContent = count + ' of 3 picked';
        this.progressEl.classList.remove('trio-buy-box__progress--complete', 'trio-buy-box__progress--celebrate');
        this.wasComplete = false;
        return;
      }

      const totals = this.trioTotals();
      this.progressEl.textContent = 'TRIO COMPLETE — SAVING ' + formatMoneyCents(totals.savings, this.moneyFormat);
      this.progressEl.classList.add('trio-buy-box__progress--complete');

      if (!this.wasComplete) {
        this.wasComplete = true;
        this.celebrate(totals.savings);
      }

      if (this.trioPriceEl) this.trioPriceEl.textContent = formatMoneyCents(totals.discounted, this.moneyFormat);
      if (this.trioSavingsEl) this.trioSavingsEl.textContent = formatMoneyCents(totals.savings, this.moneyFormat);
    }

    celebrate(savingsCents) {
      this.progressEl.classList.add('trio-buy-box__progress--celebrate');

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const prefix = 'TRIO COMPLETE — SAVING ';
      const moneyFormat = this.moneyFormat;
      const progressEl = this.progressEl;
      const duration = 500;
      let start = null;

      function tick(ts) {
        if (start === null) start = ts;
        const t = Math.min(1, (ts - start) / duration);
        progressEl.textContent = prefix + formatMoneyCents(Math.round(savingsCents * t), moneyFormat);
        if (t < 1) {
          requestAnimationFrame(tick);
        } else {
          progressEl.textContent = prefix + formatMoneyCents(savingsCents, moneyFormat);
        }
      }
      requestAnimationFrame(tick);
    }

    dispatchProgressEvent() {
      this.dispatchEvent(new CustomEvent('trio-buy-box:update', {
        bubbles: true,
        detail: { filledCount: this.filledCount, totals: this.trioTotals(), moneyFormat: this.moneyFormat },
      }));
    }

    updateSubmitButton() {
      if (!this.submitButton) return;
      const label = this.submitButton.querySelector('span');
      const buttons = [this.submitButton, this.stickyButton].filter(Boolean);

      if (this.mode !== 'trio') {
        buttons.forEach((button) => {
          button.classList.remove('trio-buy-box__submit--muted');
          button.removeAttribute('aria-disabled');
        });
        if (label) label.textContent = this.defaultButtonText;
        return;
      }

      const count = this.filledCount;
      if (count < 3) {
        const remaining = 3 - count;
        buttons.forEach((button) => {
          button.classList.add('trio-buy-box__submit--muted');
          button.setAttribute('aria-disabled', 'true');
        });
        if (label) label.textContent = 'Pick ' + remaining + ' more scent' + (remaining > 1 ? 's' : '');
      } else {
        buttons.forEach((button) => {
          button.classList.remove('trio-buy-box__submit--muted');
          button.removeAttribute('aria-disabled');
        });
        if (label) {
          label.textContent = this.staticLabel || ('Add trio to cart — ' + formatMoneyCents(this.trioTotals().discounted, this.moneyFormat));
        }
      }
    }

    onProductFormSubmit(evt) {
      if (this.mode !== 'trio') return;
      evt.preventDefault();
      evt.stopImmediatePropagation();
      if (this.filledCount < 3) return;
      this.addTrio();
    }

    addTrio() {
      if (this.isSubmitting) return;
      if (this.filledCount < 3) return;

      const items = this.slotData.map((item) => ({ id: item.id, quantity: 1 }));

      this.isSubmitting = true;
      this.handleErrorMessage(false);
      this.setLoading(true);

      const body = { items: items };
      if (this.cart) {
        body.sections = this.cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
        this.cart.setActiveElement(document.activeElement);
      }

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description || response.message);
            return;
          }

          if (this.cart) {
            this.cart.renderContents(response);
            this.cart.classList.remove('is-empty');
          } else {
            window.location = window.routes.cart_url;
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.isSubmitting = false;
          this.setLoading(false);
          this.updateSubmitButton();
        });
    }

    setLoading(isLoading) {
      [this.submitButton, this.stickyButton].forEach((button) => {
        if (!button) return;
        button.classList.toggle('loading', isLoading);
        if (isLoading) button.setAttribute('aria-disabled', 'true');
      });

      const spinner = this.submitButton ? this.submitButton.querySelector('.loading-overlay__spinner') : null;
      if (spinner) spinner.classList.toggle('hidden', !isLoading);
    }

    handleErrorMessage(message) {
      if (!this.errorWrapper) return;
      const messageEl = this.errorWrapper.querySelector('.product-form__error-message');
      this.errorWrapper.toggleAttribute('hidden', !message);
      if (message && messageEl) messageEl.textContent = message;
    }
  });
}

if (!customElements.get('sticky-atc-bar')) {
  customElements.define('sticky-atc-bar', class StickyAtcBar extends HTMLElement {
    connectedCallback() {
      const watchSelector = this.dataset.watch;
      const target = watchSelector ? document.querySelector(watchSelector) : null;

      if (!target || !('IntersectionObserver' in window)) {
        this.classList.add('trio-buy-box__sticky--visible');
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.classList.toggle('trio-buy-box__sticky--visible', !entry.isIntersecting);
          });
        },
        { threshold: 0 }
      );

      this.observer.observe(target);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  });
}
